/* @flow */

import RequestUtil from "shared/src/utils/RequestUtil";

import Requests from "shared/src/services/Requests";

const basePath = "/searchdiscover/category/";

export type CategorySettings = {
    tabNavigation: boolean;
};

export function getSettings(country: string): Promise<CategorySettings> {
    const url = basePath + "public/category/country/" + encodeURIComponent(country) + "/settings";
    return Requests.get(url, null, { timeout: 30000, headers: RequestUtil.makeCallTreeHeader() });
}
